import { css } from '@emotion/react';

const setPhoneStyles = {
    containerTitle: css({
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '15px',
        lineHeight: '15px',
        color: '#000000',
        margin: '4px 0',
    }),
    form: css({
        background: '#DAE7FA',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 300,
        textAlign: 'center',
        padding: '15px 20px',
        marginBottom: '2px',
        'input.PhoneInputInput': {
            border: 'none',
            fontSize: '14px',
            background: '#DAE7FA',
        },
        'input.PhoneInputInput:active, input.PhoneInputInput:focus': {
            border: 'none',
            outline: 'none',
        },
    }),
    formEmail: css({
        marginBottom: '2px',
    }),
    input: css({
        background: '#DAE7FA',
        outline: 'none',
        padding: '0',
        width: '100%',
        lineHeight: 1.2,
        border: 'none',
        fontFamily: 'Montserrat',
        fontSize: 14,
        fontWeight: 400,
        textAlign: 'left',

        ['&::placeholder']: {
            color: '#004FC6',
            opacity: '0.5',
            fontSize: 14,
            fontWeight: 400,
            letterSpacing: 1,
            textAlign: 'left',
            fontFamily: 'Montserrat',
        },
    }),
    errorMessage: css({
        display: 'block',
        transition: '0.2s',
        margin: '0 0 20px 0',
        color: '#C10000',
        fontSize: 12,
    }),
    description: css({
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '16px',
        color: '#000000',
        marginBottom: '20px',
        marginTop: '2px',
    }),
    required: css({
        color: '#C10000',
    }),
    modalContainer: css({
        margin: '0 auto',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '50px',
        overflowY: 'auto',

        '@media (min-width: 600px)': {
            justifyContent: 'center',
            maxWidth: '375px',
        },
    }),
    modalContentBlock: css({
        padding: '16px',
        backgroundColor: '#ffffff',
        maxHeight: '100vh',
        overflowY: 'auto',
        zIndex: 10000,
        position: 'relative',
        ['&::-webkit-scrollbar']: {
            display: 'none',
        },
        msOverflowStyle: 'none',
        scrollbarWidth: 'none',
        '@media (min-width: 600px)': {
            borderRadius: '8px',
        },
    }),
    infoBlockDescription: css({
        display: 'flex',
        alignItems: 'center',
        color: '#000000',
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '16px',
    }),
    termsLink: css({
        textDecoration: 'underline',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '13px',
        lineHeight: '16px',
        color: '#004FC6',
    }),
    actionWrapper: css({
        marginTop: '20px',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '22px',
        marginBottom: '30px',
    }),
};

export default setPhoneStyles;
